module.exports = __webpack_public_path__ + "8cf8e7df5cf57bb38cd1797f9672c67e.mp4";